<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <!-- 工单号 -->
        <work-order-field :label="customLabel.mr_macode || '工单号'"
          v-model="form.main.mr_macode" slot="mr_macode"
          @select="onSelectVendor"
        />
        <div class="weui-cell" slot="mr_prodcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.mr_prodcode || "物料编号"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.mr_prodcode"
              placeholder="请输入物料编号"
            />
          </div>
        </div>
        <div class="weui-cell" slot="mr_prodname">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.mr_prodname || "物料名称"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.mr_prodname"
              placeholder="请输入物料名称"
            />
          </div>
        </div>
        <div class="weui-cell" slot="mr_ma_qty">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.mr_ma_qty || "工单数量"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.mr_ma_qty"
              placeholder="请输入工单数量"
            />
          </div>
        </div>
        <date-field slot="mr_date"  :label="customLabel.mr_date || '日期'" v-model="form.main.mr_date" />
        <div class="weui-cell weui-cell_select weui-cell_select-after" slot="mr_process">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.mr_process || "工序"}}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.mr_process"
              placeholder="请选择"
            >
              <option v-for="(items, index) in processList" :key="index">
                {{ items.bp_name }}
              </option>
            </select>
          </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after" slot="mr_work_class">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.mr_work_class || "班次"}}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.mr_work_class"
              placeholder="请选择"
            >
              <option>白班</option>
              <option>夜班</option>
            </select>
          </div>
        </div>
        <employee-field slot="mr_person"
          :label="customLabel.mr_person || '生产负责人'"
          v-model="form.main.mr_person"
          @select="onSelectEmployee"
        />
        <customer-field slot="mr_custname" :label="customLabel.mr_custname || '客户'"
          v-model="form.main.mr_custname"
          @select="onSelectCustomer"
        />
        <div class="weui-cell" slot="mr_qty">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.mr_qty || "检验数量"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.mr_qty"
              minvalue="0"
              maxvalue="99999999"
              @change="calculation"
              @blur="calculation"
            />
          </div>
        </div>
        <div class="weui-cell" slot="mr_ng_qty">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.mr_ng_qty || "不良品数"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.mr_ng_qty"
              minvalue="0"
              maxvalue="99999999"
              @change="calculation"
              @blur="calculation"
            />
          </div>
        </div>
        <div class="weui-cell" slot="mr_ng_rate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.mr_ng_rate || "不良率"}}</label>
          </div>
          <div class="weui-cell__bd flex">
            <span>{{ form.main.mr_ng_rate }}%</span>
          </div>
        </div>
        <div class="weui-cell" slot="mr_ok_rate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.mr_ok_rate || "目标值"}}</label>
          </div>
          <div class="weui-cell__bd flex">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.mr_ok_rate"
              minvalue="0"
            />
            <span>%</span>
          </div>
        </div>
      </custom-layout>
      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="'1-' + xindex"
      >
        <div class="weui-cells__title">
          <span>原因分析{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
        <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-cell" slot="mrd_sn_code">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.mrd_sn_code || "S/N编号"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.mrd_sn_code"
                placeholder="请填写"
              />
            </div>
          </div>

          <div class="flex flex-center" slot="mrd_nk_reason">
            <check-group-field
              class="flex-1" 
              :label="customLabel.mrd_nk_reason || '不良现象'"
              :items="reasonList"
              v-model="item.mrd_nk_reason"
            />
            <span
              class="iconfont icon-add blue-color width-20"
              @click="openReason()"
            ></span>
          </div>
          <div class="weui-cell" slot="mrd_nk_cause">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.mrd_nk_cause || "不良现原因"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.mrd_nk_cause"
                placeholder="请填写"
              />
            </div>
          </div>
          <employee-field slot="mrd_check"
            :label="customLabel.mrd_check || '维修人'"
            v-model="item.mrd_check"
            @select="onSelectEmployee2($event, xindex)"
          />

          <date-field slot="mrd_date" :label="customLabel.mrd_date || '维修日期'" v-model="item.mrd_date" />
          <combo-search-box slot="mrd_result"
            :label="customLabel.mrd_result || '维修方法'"
            placeholder="请选择或输入维修方法"
            v-model="item.mrd_result"
            url="/api/make/makeRepairKind/getCombo"
            ref="combo1"
          />
          <div class="weui-cell" slot="mrd_info">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.mrd_info || "维修详情"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.mrd_info"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell" slot="mrd_remark">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.mrd_remark || "备注"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.mrd_remark"
                placeholder="请填写"
              />
            </div>
          </div>
        </custom-layout>
        <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
    <div class="mark" v-if="pindex != -1">
      <div class="page page__has-bar">
        <div class="page__bd">
          <div
            class="weui-cells__group"
            v-for="(item, gindex) in table"
            :key="gindex"
          >
            <div class="weui-cells__title">
              <span>不良现象{{ gindex + 1 }}</span>
              <a
                href="javascript:;"
                class="header-tool"
                @click="removeReason(gindex)"
              >
                <span>删除</span>
              </a>
            </div>
            <div class="weui-cells">
              <div class="weui-cell">
                <div class="weui-cell__hd">
                  <label for class="weui-label">检查项 </label>
                </div>
                <div class="weui-cell__bd">
                  <input
                    class="weui-input"
                    type="text"
                    v-model="item.nk_check"
                    placeholder="请填写"
                  />
                </div>
              </div>
              <div class="weui-cell">
                <div class="weui-cell__hd">
                  <label for class="weui-label">不良现象</label>
                </div>
                <div class="weui-cell__bd">
                  <input
                    class="weui-input"
                    type="text"
                    v-model="item.nk_ng_reason"
                    placeholder="请填写"
                  />
                </div>
              </div>
            </div>
          </div>
          <a
            href="javascript:"
            class="weui-cell weui-cell_link"
            @click="addReason"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
        <div class="footer-bar weui-dialog__ft">
          <a
            href="javascript:;"
            class="weui-dialog__btn weui-dialog__btn_primary"
            @click="determine()"
            >确定</a
          >
          <a
            href="javascript:;"
            class="weui-dialog__btn weui-dialog__btn_default"
            @click="() => (pindex = -1)"
            >取消</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import CheckGroupField from "@/components/field/CheckGroupField.vue";
import ComboSearchBox from "@/components/field/ComboSearchBox.vue";
import DateField from "@/components/field/DateField.vue";
import WorkOrderField from "@/components/field/WorkOrderField.vue";
import CustomerField from "@/components/field/CustomerField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout,
    CheckGroupField,
    ComboSearchBox,
    WorkOrderField,
    DateField,
    CustomerField,
    EmployeeField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/make/makeRepair",
      codeField: "mr_code",
      caller: "MakeRepair",
      xtype: "make-makeRepair-formpanel",
      pindex: -1,
      form: {
        main: {
          mr_person: null,
          mr_ok_rate: 98,
          mr_date: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
        },
        items: [
          {
            mrd_sn_code: null,
            mrd_nk_reason: null,
            mrd_checkId: 0,
            mrd_check: null,
            mrd_date: this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss"),
          },
        ],
      },
      processList: [],
      reasonList: [],
      table: [],
    };
  },
  methods: {
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({});
    },
    //选择工单号
    onSelectVendor(selection) {
      var me = this,
        main = me.form.main,
        items = me.form.items;
      main.mr_prodid = selection.ma_prodid;
      main.mr_macode = selection.ma_code;
      main.mr_prodcode = selection.ma_prodcode;
      main.mr_prodname = selection.ma_prdetail;
      main.mr_ma_qty = selection.ma_qty;
      main.mr_process = null;
      items.mrd_nk_reason = null;
      me.getWorkingProcedure(main.mr_prodid);
      me.getReasonList(main.mr_prodid);
    },
    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.mr_person_id = selection.id;
    },
    onSelectEmployee2(selection, key) {
      var me = this,
        items = me.form.items;
      items[key].mrd_checkId = selection.id;
      
    },
    /**
     * 选择客户
     */
    onSelectCustomer(selection) {
      var main = this.form.main;
      main.mr_custid = selection.id;
      main.mr_custcode = selection.cu_code;
    },
    /**
     * 请求工序下拉列表
     */
    getWorkingProcedure(id) {
      var me = this;
      me.$ajax({
        url: "/api/make/bomProcess/processlist/" + id,
      }).then(function (res) {
        if (res.success) {
          me.processList = res.data;
        }
      });
    },
    /**
     * 请求不良现象
     */
    getReasonList(id) {
      var me = this;
      me.reasonList = [];
      me.$ajax({
        url: "/api/qc/makeQcNgKind/getList/" + id,
      }).then(function (res) {
        if (res.success) {
          res.data.forEach((item) => {
            me.reasonList.push({
              display: item.nk_ng_reason,
              value: item.nk_ng_reason,
            });
          });
        }
      });
    },
    addReason() {
      var me = this,
        main = me.form.main;
      me.table.push({
        nk_detno: null,
        nk_ng_reason: null,
        nk_check: null,
        nk_prodcode: main.mr_prodcode,
        nk_prodid: main.mr_prodid,
        nk_prodname: main.mr_prodname,
      });
    },
    removeReason(index) {
      var me = this,
        table = me.table;
      if (table.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        table.splice(index, 1);
      }
    },
    openReason(xindex) {
      var me = this,
        main = me.form.main;
      if (main.mr_prodid) {
        me.pindex = xindex;
        me.table = [];
        me.$ajax({
          url: "/api/qc/makeQcNgKind/getList/" + main.mr_prodid,
        }).then(function (res) {
          if (res.success) {
            me.table = res.data;
          }
        });
      } else {
        me.$weui.topTips("请选择工单号", 2000);
      }
    },
    determine() {
      var me = this,
        main = me.form.main,
        count = 0;
      me.table.forEach(function (item) {
        if (!item.nk_check) {
          me.$weui.topTips(`第${count + 1}行检查项未填写`, 2000);
          return false;
        } else if (!item.nk_ng_reason) {
          me.$weui.topTips(`第${count + 1}行不良现象未填写`, 2000);
          return false;
        } else {
          count++;
          item.nk_detno = count;
        }
      });
      me.$loading({
        url: "/api/qc/makeQcNgKind/save",
        method: "POST",
        jsonData: me.table,
      })
        .then(function (res) {
          if (res.success) {
            me.$weui.toast("保存成功", 2000);
            me.getReasonList(main.mr_prodid);
          } else {
            me.$weui.topTips(res.message, 3000);
          }
        })
        .catch(function () {
          me.$weui.topTips("保存失败", 3000);
        });
      me.pindex = -1;
    },
    /**
     * 计算不良率
     */
    calculation() {
      var me = this,
        main = me.form.main,
        num= 0;
      main.mr_qty = Number(main.mr_qty);
      main.mr_ng_qty = Number(main.mr_ng_qty);
      if (main.mr_qty && main.mr_ng_qty) {
        num = (main.mr_ng_qty / main.mr_qty) * 100;
        main.mr_ng_rate = me.$number.round(num , 2)
      }
    },
    result_combo_save(mrd_result, key) {
      var me = this;
      let combo1 = me.$refs.combo1[key].data,
        save = combo1.some((item) => {
          return item.value == mrd_result;
        });
      if (!save) {
        me.$ajax({
          url: "/api/make/makeRepairKind/save",
          method: "POST",
          jsonData: {
            mrk_name: mrd_result,
            id: 0,
          },
        }).then();
      }
    },
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        requiredMap = me.getDetailRequired()

      if (!main.mr_macode) {
        me.$weui.topTips("请选择工单号", 2000);
      } else if (!main.mr_person) {
        me.$weui.topTips("请选择生产负责人", 2000);
      } else if (!main.mr_qty) {
        me.$weui.topTips("请输入检验数量", 2000);
      } else if (!main.mr_ng_qty) {
        me.$weui.topTips("请输入不良品数", 2000);
      } else {
        var count = 0;
        items.forEach(function (item) {
          if (requiredMap['mrd_nk_reason'] && !item.mrd_nk_reason) {
            me.$weui.topTips(`第${count + 1}行不良现象未选择`, 2000);
            return false;
          } else if (requiredMap['mrd_check'] && !item.mrd_check) {
            me.$weui.topTips(`第${count + 1}行维修人未选择`, 2000);
            return false;
          } else if (requiredMap['mrd_date'] && !item.mrd_date) {
            me.$weui.topTips(`第${count + 1}行维修日期未选择`, 2000);
            return false;
          } else if (requiredMap['mrd_result'] && !item.mrd_result) {
            me.$weui.topTips(`第${count + 1}行维修方法未填写`, 2000);
          } else if (requiredMap['mrd_info'] && !item.mrd_info) {
            me.$weui.topTips(`第${count + 1}行维修详情未填写`, 2000);
          } else {
            count++;
            item.mr_detno = count;
          }
        });
      }
      if (count) {
        items.forEach((item, index) => {
          me.result_combo_save(item.mrd_result, index);
        });
        main.mr_qty = me.$number.round(main.mr_qty || 0, 3);
        main.mr_ng_qty = me.$number.round(main.mr_ng_qty || 0, 3);
        main.mr_ok_rate = me.$number.round(main.mr_ok_rate || 0, 2);
        me.p_save();
      }
    },
  },
};
</script>

<style scoped>
.mark {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 500;
  overflow-y: scroll;
}
.flex {
  display: flex;
}
.flex-center {
  align-items: center;
}
.flex-1 {
  flex: 1;
}
.width-20 {
  text-align: center;
  width: 50px;
}
.blue-color {
  color: #576b95;
}
</style>